import { useQuery } from 'react-query';

import { apiClient } from 'src/services/api/client';
import { GET_LEADS_PATH } from 'src/services/api/leads/constants';
import {
    fromWire,
    getLeadFactsQueryKey,
    type ListSuggestionsWire,
} from 'src/services/api/leads/lead-facts';

/**
 * The lead's suggestion rows (`pending` feeds the nudges). Fact *values* are the
 * lead's own columns, already returned with the lead — this only feeds the nudge UI.
 */
export const useLeadFacts = (leadUuid: string) =>
    useQuery(getLeadFactsQueryKey(leadUuid), async () => {
        const res = await apiClient(
            `${GET_LEADS_PATH}/${leadUuid}/suggestions`
        ).json<ListSuggestionsWire>();
        return res.suggestions.map(fromWire);
    });
